<template>
  	<div id="allmap" v-bind:style="mapStyle"></div>
</template>
<script>
	import imgs from '../img/icon-site.png'
	import util from '../common/js/util'
	import { getDeviceList, removeOrgan, batchRemoveUser, editUser, addUser } from '../api/api';
	
export default {
	data(){
	  return{
	  	zoom:10,
	  	center:{
	  		lng:'',
	  		lat:'',
	  	},
	    mapStyle:{
	      width:'100%',
	      height:'100%',
	    },
	    devices:[],
	    deviceList:[],
	    map:{},
	    label:{},
	    labelList:[]
	  }
	},
	mounted() {
		this.getlocation()
	}, 
	methods: {
		sendlocation:function(){
			var that=this
			this.$axios.get('/apis/ws/location/v1/ip', {
				params:{
					'key':"L52BZ-EBJ3X-CTQ4E-TWKC5-ASHAV-MXFNX"
				}
			}).then(res => {
				console.log(res.data.result.location)
				that.init(res.data.result.location)
			}).catch(err =>{
				console.log(err)
			})
		},
		setlocation:function(){
			var position={
				lat:31.113251,
				lng:121.382057,
			}
			this.init(position)
		},
		getlocation:function(){
			var params={
				'key':"L52BZ-EBJ3X-CTQ4E-TWKC5-ASHAV-MXFNX",
				output:'jsonp'
			}
			this.$jsonp('https://apis.map.qq.com/ws/location/v1/ip',params)
			.then(json => {
				this.init(json.result.location)
			})
		},
		init:function (position) {
			var that=this
      		this.center = new window.qq.maps.LatLng(position.lat,position.lng);
	      	var myOptions = {
		        zoom: that.zoom,
		        center: that.center,
		        mapStyleId: '',  // 该key绑定的style1对应于经典地图样式，若未绑定将弹出无权限提示窗
		        mapTypeId: window.qq.maps.MapTypeId.ROADMAP
	      	}
	      	this.map = new window.qq.maps.Map(document.getElementById("allmap"), myOptions);
		      //添加监听地图事件
      		window.qq.maps.event.addListener(this.map, 'click', function(event) {
	        	console.log('您点击的位置为: [' + event.latLng.getLat() + ', ' +
		          event.latLng.getLng() + ']');
	      	});
	      	window.qq.maps.event.addListener(this.map, 'dragend', function(event) {
	        	that.zoom= this.getZoom()
	        	that.center=this.getCenter()
	        	that.deleteOverlays()
	        	that.getdeviceList()
	      	});
	      	window.qq.maps.event.addListener(this.map, 'zoom_changed', function(event) {
	        	that.zoom= this.getZoom()
	        	that.center=this.getCenter()
	        	that.deleteOverlays()
	        	that.getdeviceList()
	      	});
	    this.getdeviceList()
	  },
		getdeviceList:function(){
			var that=this
			let para = {
					mac_id:'',
					organ_sysno:this.GLOBAL.organ_sysno,
					prop: "lastTime",
					sort: "desc",
					pageNo:1,
					pageSize:80,
					maptype:'txmap',
					zoom:this.zoom,
					center:{
						lng:this.center.lng,
						lat:this.center.lat,
					},
			};
			this.listLoading = true;
			console.log(para)
			console.log(para.zoom)
			getDeviceList(para).then((res) => {
				console.log(res)
				var that=this
				this.total = res.data.data.list.length;
				this.devices = res.data.data.list;
				console.log(res.data.data.list.length)
				this.listLoading = false;
				for(let i=0;i<res.data.data.list.length;i++){
					var marker = new window.qq.maps.Marker({
					    position: new window.qq.maps.LatLng(res.data.data.list[i].lat,res.data.data.list[i].lng),
					    map: that.map
					});
					that.deviceList.push(marker)
					//设置动画
//					marker.setAnimation(qq.maps.MarkerAnimation.DOWN);
					////设置Marker自定义图标的属性，size是图标尺寸，该尺寸为显示图标的实际尺寸，origin是切图坐标，该坐标是相对于图片左上角默认为（0,0）的相对像素坐标，anchor是锚点坐标，描述经纬度点对应图标中的位置
			    	var anchor = new qq.maps.Point(8, 24)
		      		var size = new qq.maps.Size(18, 27)
		      		var origin = new qq.maps.Point(0, 0)
		      		var scaleSize=new qq.maps.Size(18, 27)
		      		var icon = new qq.maps.MarkerImage(imgs,size,origin,anchor,scaleSize);
			    	marker.setIcon(icon);
    			//设置标注的名称，当鼠标划过Marker时显示
			        var Label = function(opts) {
				        qq.maps.Overlay.call(this, opts);
				    }
		        	Label.prototype = new qq.maps.Overlay();
		        //提示框样式
			        Label.prototype.construct = function() {
				        this.dom = document.createElement('div');
				        this.dom.style.cssText =
				            'background:rgba(0, 0, 0,0.6);color:white;position:absolute;' +
				            'text-align:center;padding: 10px;font-size: 12px;text-align: left;min-width: 200px;';
				       	var addr=``
				        if(!!this.device.address){
				        	addr=`<p>地址：${this.device.address}</p>`
				        }
				        this.dom.innerHTML = `<p>连接用户：${this.device.user_name}</p><p>设备物理地址：${this.device.mac_id}</p><p>连接时间：${this.device.lastTime}</p>${addr}`;
				        //将dom添加到覆盖物层，overlayLayer的顺序为容器 1，此容器中包含Polyline、Polygon、GroundOverlay等
				        this.getPanes().floatPane.appendChild(this.dom);
				    }
//				    绘制和更新自定义的dom元素
				    Label.prototype.draw = function() {
				        //获取地理经纬度坐标,更新位置
				        var position = this.get('position');
				        if (position) {
				            //根据经纬度坐标计算相对于地图外部容器左上角的相对像素坐标
				            //var pixel = this.getProjection().fromLatLngToContainerPixel(position);
				            //根据经纬度坐标计算相对于地图内部容器原点的相对像素坐标
				            var pixel = this.getProjection().fromLatLngToDivPixel(position);
				            this.dom.style.left = pixel.getX() + 'px';
				            this.dom.style.top = pixel.getY()+10 + 'px';
				        }
				    }
				    Label.prototype.destroy = function() {
				    	console.log('当前移除图标')
				        //移除dom
				        this.dom.parentNode.removeChild(this.dom);
				    }
    				//标记Marker点击事件
				    qq.maps.event.addListener(marker, 'mouseover', function() {
					    that.label = new Label({
					        map: that.map,
					        position: new window.qq.maps.LatLng(that.devices[i].lat,that.devices[i].lng),
					        device:that.devices[i]
					    });
					    that.labelList.push(that.label)
				    });
				    qq.maps.event.addListener(marker, 'mouseout', function() {
				    	that.labelList=[]
				    	if(!!that.label){
				    		that.label.destroy()
				    	}
				    });
				}
			}).catch((error) =>{
				console.log(error)
			});
		},
		//删除覆盖物
		deleteOverlays:function () {
		    if (this.deviceList) {
		        for (let i in this.deviceList) {
		            this.deviceList[i].setMap(null);
		        }
		        this.deviceList.length = 0;
		    }
		    if (this.labelList) {
		        for (let i in this.labelList) {
		            this.labelList[i].setMap(null);
		        }
		        this.labelList.length = 0;
		    }
		},
	}
}
</script>
 
<!--Add"scoped" attribute to limit CSS to this component only -->
<style >
  
</style>


// WEBPACK FOOTER //
// src/components/map.vue